import { baseTheme, ThemeTransitions } from '@feast-it/ui/light';

export function getTransitionDuration(input: keyof ThemeTransitions): number {
  const durationString = baseTheme.transitions[input];
  const match = durationString.match(/^([\d.]+)s$/);

  return parseFloat(match[1]);
}
